
<div class="modal-dialog confirm-dialog" style="display: flex; justify-content: center;">
  <div class="modal-content" style="min-width:750px;">
    <div class="modal-header" style="flex-direction: column;">
      <div class="w-100 d-flex justify-content-between">
        <h4 class="modal-title">{{isCreateSelected ? 'Create' : 'Select'}} Customer Opportunity Group</h4>
        <button class="close" type="button" (click)="cancel()">&times;</button>
      </div>
      <div class="w-100 mt-2 d-flex justify-content-end">
        <button class="btn btn-outline-primary" type="button" (click)="changeOpportunitySelected()">
           {{isCreateSelected ? 'Select Customer Opportunity Group' : 'Create Customer Opportunity Group'}}</button>
      </div>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <div *ngIf="isCreateSelected; then createOpportunityGroupTemplate else selectOpportunityGroupTemplate"></div>
    </div>
    <div class="modal-footer" style="display: flex; justify-content: start;"><span *ngIf="!isCreateSelected">Selected Customer Opportunity Group: {{ selectedCustomerOpportunityGroup?.customerOpportunityGroupName }}</span>
      <button class="btn btn-outline-secondary px-4 ml-auto" type="button" (click)="cancel()">Cancel</button>
      <button class="btn btn-primary px-4" id="doneSearchOpportunityGroup" *ngIf="!isCreateSelected" type="button" (click)="selectOpportunityGroupComplete()" [disabled]="!selectedCustomerOpportunityGroup?.customerOpportunityGroupId || loading">Done</button>
      <button class="btn btn-primary px-4" id="doneCreateOpportunityGroup" *ngIf="isCreateSelected" type="button" (click)="createCustomerOpportunityGroup()" [disabled]="isDisabledCreateButton()">Create</button>
    </div>
  </div>
</div>
<ng-template #selectOpportunityGroupTemplate>
  <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"></list-controls>
  <table class="table table-striped">
    <thead>
      <tr *ngIf="!!customerOpportunityGroupsListDisplay.length">
        <th></th>
        <th>Name</th>
      </tr>
    </thead>
    <tbody>
      <ng-template [ngIf]="!loading &amp;&amp; customerOpportunityGroupsListDisplay.length">
        <tr *ngFor="let customerOpportunityGroup of customerOpportunityGroupsListDisplay, let i = index">
          <td class="form-group">
            <div class="form-check tmc-radio px-4">
              <input id="selectedCustomerOpportunityGroupRadio{{i}}" type="radio" name="selectedCustomerOpportunityGroupRadio" (change)="customerOpportunityGroupSelectedEvent(customerOpportunityGroup.customerOpportunityGroupId)" [checked]="customerOpportunityGroup.customerOpportunityGroupId === selectedCustomerOpportunityGroup.customerOpportunityGroupId">
            </div>
          </td>
          <td class="w-100">{{ customerOpportunityGroup?.customerOpportunityGroupName }}</td>
        </tr>
      </ng-template>
      <ng-template [ngIf]="!loading &amp;&amp; !customerOpportunityGroupsListDisplay.length">
        <tr>
          <td colspan="3">
            <p class="text-center empty-table-message">There are no customer opportunity groups to display.</p>
          </td>
        </tr>
      </ng-template>
      <ng-template [ngIf]="loading">
        <tr>
          <td colspan="4">
            <md-spinner-block></md-spinner-block>
          </td>
        </tr>
      </ng-template>
    </tbody>
  </table>
</ng-template>
<ng-template #createOpportunityGroupTemplate>
  <div class="container">
    <ng-container *ngIf="loading">
      <md-spinner-block></md-spinner-block>
    </ng-container>
    <ng-container *ngIf="!loading">
      <div class="row">
        <div class="form-group col-12">
          <label class="required bold" for="customerOpportunityGroupName">Customer Opportunity Group Name</label>
          <input class="form-control" id="customerOpportunityGroupName" [(ngModel)]="customerOpportunityGroupNameInput" name="customerOpportunityGroupName" type="text" maxLength="100" autoLinkToLabel>
        </div>
      </div>
      <div class="row" *ngIf="globalOpportunityId">
        <div class="form-group col-12">
          <label class="required bold" for="leadCustomerNameInput">Lead Customer {{ !enableTaxNumberSearch ? 'Name' : null}}</label>
        </div>
      </div>
      <div class="row" style="margin-top:-1.5rem;margin-left: -0.5rem" *ngIf="enableTaxNumberSearch &amp;&amp; globalOpportunityId">
        <div class="col-lg-2" style=" font-size: 14px;margin-right: -0.8rem;">Search By:</div>
        <div class="form-group col-lg-9" style="margin-left:-0.9rem;">
          <input class="form-check-input" type="radio" autoLinkToLabel [disabled]="leadCustomerState === 1 || leadCustomerSet" [value]="name" name="leadCustomerSearchType" (click)="checkLeadCustomerSearchBy('name')" [checked]="leadCustomerSearchBy == 'name'">
          <label class="form-check-label" style="font-size:12px">Name</label>
          <input class="form-check-input" type="radio" autoLinkToLabel [disabled]="leadCustomerState === 1 || leadCustomerSet" style="margin-left: 1rem" [value]="bpid" name="leadCustomerSearchType" (click)="checkLeadCustomerSearchBy('bpid')" [checked]="leadCustomerSearchBy == 'bpid'">
          <label class="form-check-label" style="font-size:12px;margin-left: 2.1rem;">BPID</label>
          <input class="form-check-input" type="radio" autoLinkToLabel [disabled]="leadCustomerState === 1 || leadCustomerSet" style="margin-left: 1rem" [value]="taxNumber" name="leadCustomerSearchType" (click)="checkLeadCustomerSearchBy('taxNumber')" [checked]="leadCustomerSearchBy == 'taxNumber'">
          <label class="form-check-label" style="font-size:12px;margin-left: 2.1rem;">Tax Number</label>
        </div>
      </div>
      <div class="row" *ngIf="globalOpportunityId" style="margin-top: -0.8rem;">
        <div class="form-group col-lg-12">
          <div class="input-group">
            <input class="form-control" id="leadCustomerNameInput" [disabled]="leadCustomerState === 1 || leadCustomerSet" [(ngModel)]="leadCustomerName" name="leadCustomerNameInput" type="text" maxlength="100" placeholder="{{leadCustomerSearchBy==='name' &amp;&amp; enableTaxNumberSearch ? 'Enter Lead Customer Name':leadCustomerSearchBy=='bpid' &amp;&amp; enableTaxNumberSearch ? 'Enter Lead Customer BPID': leadCustomerSearchBy == 'taxNumber' &amp;&amp; enableTaxNumberSearch ? 'Enter Tax Number' : null}}" required>
            <div class="input-group-append">
              <button class="btn btn-primary" id="searchCustomerOpportunityGroupName" type="button" (click)="searchLeadCustomer()" [disabled]="!(leadCustomerName || '').length || leadCustomerState === 1 || leadCustomerSet">Go</button>
            </div>
          </div>
          <validation-error-display [error]="error" field="customerOpportunityGroupName"></validation-error-display><a *ngIf="leadCustomerState === 3  &amp;&amp; leadCustomerErrorMessages !== null" style="color:red;" href="javascript:void(0);" (click)="showErrorMessages()">Error - See more details</a><span class="d-block" *ngIf="leadCustomerState === 1" style="color: green;">{{ leadCustomerMessage }}</span>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>